import gql from 'graphql-tag';
const TEACHER_CREATION_ACTIVITY_FRAGMENT = gql `
  fragment TeacherCreationActivityFragment on TeacherCreationActivity {
    teacherCreatedActivityId
    rounds {
      id
      steps {
        id
        answer
      }
    }
  }
`;
export default TEACHER_CREATION_ACTIVITY_FRAGMENT;
